/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { GetAodRulesScheduledRunsQueryResponse, GetAodRulesScheduledRunsPathParams, GetAodRulesScheduledRuns404 } from "../models/GetAodRulesScheduledRuns";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getAodRulesScheduledRuns } from "../axios/getAodRulesScheduledRuns";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getAodRulesScheduledRunsQueryKey = (id: GetAodRulesScheduledRunsPathParams["id"]) => ["audit-reports-api", { url: '/aod-rules/:id/scheduled-runs', params: {id:id} }] as const

export type GetAodRulesScheduledRunsQueryKey = ReturnType<typeof getAodRulesScheduledRunsQueryKey>

export function getAodRulesScheduledRunsQueryOptions(id: GetAodRulesScheduledRunsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getAodRulesScheduledRunsQueryKey(id)
        return queryOptions<GetAodRulesScheduledRunsQueryResponse, ResponseErrorConfig<GetAodRulesScheduledRuns404>, GetAodRulesScheduledRunsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getAodRulesScheduledRuns(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for a specific AOD rule. Deprecated: Use GET /aod-runs/scheduled/rules/:ruleId instead
 * @summary Get scheduled runs for an AOD rule
 * {@link /aod-rules/:id/scheduled-runs}
 * @deprecated
 */
export function useGetAodRulesScheduledRuns<TData = GetAodRulesScheduledRunsQueryResponse, TQueryData = GetAodRulesScheduledRunsQueryResponse, TQueryKey extends QueryKey = GetAodRulesScheduledRunsQueryKey>(id: GetAodRulesScheduledRunsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<GetAodRulesScheduledRunsQueryResponse, ResponseErrorConfig<GetAodRulesScheduledRuns404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getAodRulesScheduledRunsQueryKey(id)
         

         const query = useQuery({
          ...getAodRulesScheduledRunsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetAodRulesScheduledRuns404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}